import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const CustomDropdownButton = styled(DropdownButton)`
    .dropdown-toggle::after {
        display: none !important;  /* This is to hide the caret */
    }

    .gi-button__outline{
        line-height: 1;
        font-weight: 400;
        padding: 10px 16px;
        border-radius: 4px;
        @media screen and (max-width: 640px){
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }
`;

const DropDownMenu = (props) => {

    const {
        onFieldChange, spokenOrWrittenLanguage
    } = props;

    const handleSelect = (eventKey) => {
        onFieldChange(spokenOrWrittenLanguage, eventKey);
    };

    return (
        <CustomDropdownButton
            id={`${spokenOrWrittenLanguage}_dropdown_button`}
            data-testid={`${spokenOrWrittenLanguage}_dropdown`}
            title={<FormattedMessage id='ssap.button.change' />}
            bsPrefix="gi-button__outline"
            onSelect={handleSelect}
        >
            <Dropdown.Item eventKey="English" as="div" className='usa-button gi-button text-center'>
                <FormattedMessage id="ssap.input.option.language_english" />
            </Dropdown.Item>
            <Dropdown.Item eventKey="Spanish" as="div" className='usa-button gi-button text-center'>
                <FormattedMessage id="ssap.input.option.language_spanish" />
            </Dropdown.Item>
        </CustomDropdownButton>
    );
};

export default DropDownMenu;
